export default function BrandHeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_94913593acd8d88fec3da49e4088cf9d_513b9939.jpg"
          alt="Sustainable Brand"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          Sustainable Brand
        </h1>
        <div className="w-24 h-1 bg-emerald-500 mx-auto mb-10"></div>
        <p className="text-xl md:text-2xl text-white/95 leading-relaxed max-w-3xl mx-auto">
          버려지는 자원에 새로운 가치를 더해
          <br />
          지속가능한 미래를 만들어갑니다
        </p>
      </div>

      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/80"></i>
      </div>
    </section>
  );
}